<template>
  <div class="py-4 bg-secondary">
    <div class="profile-page" style="min-height: 764px;">
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{ $t('menu.main') }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ $t('menu.pro_active') }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ $t('submenu.reference') }}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section class="section py-3">
        <div class="container">
          <card shadow class="card-profile mt--100 card_radius_no" no-body>
            <div class="px-4">
              <div class="text-center mt-2">
                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                    class="news_title">{{ $t('reference.reference_title') }}</span></div>
              </div>
              <div class="mt-1 py-5">
                <div class="row">
                  <div class="col-lg-12">
                    <el-collapse v-model="activeName" accordion>
                      <el-collapse-item :title="$t('reference.reference_yil8')" name="1"
                                        class="text-center">
                        <p style="text-align: justify;">
                          {{ $t('reference.reference_yil8_text') }}</p>
                      </el-collapse-item>
                      <el-collapse-item :title="$t('reference.reference_yil7')" name="2"
                                        class="text-center">
                        <p style="text-align: justify;">
                          {{ $t('reference.reference_yil7_text') }}</p>
                      </el-collapse-item>
                      <el-collapse-item :title="$t('reference.reference_yil6')" name="3"
                                        class="text-center">
                        <p style="text-align: justify;">
                          {{ $t('reference.reference_yil6_text') }}</p>
                      </el-collapse-item>
                      <el-collapse-item :title="$t('reference.reference_yil5')" name="4"
                                        class="text-center">
                        <p style="text-align: justify;">
                          {{ $t('reference.reference_yil5_text') }}</p>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: '1'
    };
  }
}
</script>
<style scoped>
/deep/ .el-collapse-item__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 48px;
  line-height: initial !important;
  background-color: #fff;
  color: #303133;
  cursor: pointer;
  border-bottom: 1px solid #EBEEF5;
  font-size: 13px;
  font-weight: 500;
  -webkit-transition: border-bottom-color .3s;
  transition: border-bottom-color .3s;
  outline: none;
}
</style>

